module.exports = __webpack_public_path__ + "media/images/icon__email-c3d80aa5b28c6a11975179c6aa0db2e4.png";